import { FaFacebook } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { RootState } from "../../store/store";
import { blogListApi } from "../../service/apis/bloglisting.api";
import { useEffect, useState } from "react";
import Loader from "../../common/Loader/loader";

const FooterScreen = () => {
    const [responseData, setResponseData] = useState([]);
    
    const { footerlogo, footerContent, copyright, twitterUrl, linkedinUrl, instagramUrl } = useSelector((state: RootState) => {
        //console.log(state);
        return state.globalDataSlice.Global;
    });

    const navigatee = useNavigate();

    const handleNavigation = (event: any, path: any) => {
    event.preventDefault();
    navigatee(path);
    };
    

    const blogLists = async(pagee: number) => {
        //setIsLoading(true);
        try {
            const response = await blogListApi(pagee);
            setResponseData(response.blogData.Blogs);
        } catch (error) {
            console.error("Catch Error: ", error);
        } finally {
            //setIsLoading(false);
        }
    };

    const isActivee = (path: string, isParent: boolean = false): string => {
        const currentPath: string = window.location.pathname;

        if (isParent) {
        // Mark as active only if currentPath matches exactly the parent path
        return currentPath === path ? "active" : "";
        }

        // For child items, mark as active only if currentPath matches the exact path
        return currentPath === path ? "active" : "";
    };
    useEffect(() => {
        blogLists(1);
    }, []);
    //console.log("Footer called");

    return (
        <>
            <footer className="main-footer common-padd-lt-rt ">
                <div className="footertop common-padd-xl">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="logoinfoftr">
                                    <div className="logo text-left">
                                        {/* <a href=""><img src={LogoImg} alt="logo" /></a> */}
                                        <Link to='/'><img src={footerlogo} alt="logo" /></Link>
                                    </div>
                                    <p>{footerContent}</p>
                                    <ul className="socialmedia">
                                        {twitterUrl && (
                                            <li>
                                                <Link to={twitterUrl} target="_blank" rel="noopener noreferrer"><FaFacebook /></Link>
                                            </li>
                                        )}
                                        {linkedinUrl && (
                                            <li>
                                                <Link to={linkedinUrl} target="_blank" rel="noopener noreferrer"><FaLinkedin /></Link>
                                            </li>
                                        )}
                                        {instagramUrl && (
                                            <li>
                                                <Link to={instagramUrl} target="_blank" rel="noopener noreferrer"><FaInstagram /></Link>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 ">
                                <div className="company">
                                    <h4>Company</h4>
                                    <ul>
                                        <li className={isActivee("/about")}>
                                            {/* <a href="#">About Us</a> */}
                                            <Link to='/about' onClick={(e) => handleNavigation(e, "/about")}>About Us</Link>
                                        </li>
                                        <li className={isActivee("/our-recruitment-services")}><Link to='/our-recruitment-services' onClick={(e) => handleNavigation(e, "/our-recruitment-services")}>Recruitment Services</Link></li>
                                        <li className={isActivee("/our-immigration-services")}><Link to='/our-immigration-services' onClick={(e) => handleNavigation(e, "/our-immigration-services")}>Immigration Services</Link></li>
                                        <li className={isActivee("/blog")}><Link to='/blog' onClick={(e) => handleNavigation(e, "/blog")}>Blog</Link></li>
                                        <li className={isActivee("/faq")}><Link to='/faq' onClick={(e) => handleNavigation(e, "/faq")}>FAQ's</Link></li>
                                        <li className={isActivee("/contact-us")}><Link to='/contact-us' onClick={(e) => handleNavigation(e, "/contact-us")}>Contact Us</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="featuredtopics">
                                    <h4>Featured Topics</h4>
                                    <ul>
                                    {responseData ? (
                                        responseData.slice(0, 3).map((blog: any) => (
                                            <li key={blog._id}>
                                                {/* <a href="#">{blog.title}</a> */}
                                                <Link to={`/blog-details/${blog.slug}`}>{blog.title}</Link>
                                            </li>
                                        ))
                                    ) : (
                                        <Loader />
                                    )}
                                        {/* <li><a href="">13 Must-Ask Executive Interview Questions to Secure a Visionary Leader</a></li>
                                        <li><a href="">4 Tips for Finding the Right Recruiter who Specializes in Hiring Freelancers</a></li> */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-6">
                            {/* <p>Copyright © 2024 <strong>Pelorus Group Inc.</strong> <span>All rights reserved.</span></p> */}
                            <p>{copyright}</p>
                        </div>
                        <div className="col-sm-6 terms-privacy">
                            <ul>
                                <li><Link to='/terms-conditions'>Terms & Conditions</Link></li>
                                <li><Link to='/privacy-policy'>Privacy Policy</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>


        </>
    )
}
export default FooterScreen;